import { defineStore } from 'pinia';
import {http} from '../../utils/http';
export const useSettingsStore = defineStore('wpcm-settings', {
  state: () => ({
    loading: false,
    values: {},
    tabs: []
  }),
  getters: {
    getValues: (state) => state.values,
    getTabs: (state) => state.tabls,
  },
  actions: {
    getData() {
      this.loading = true
      return http.post({
        action: "_wpcommerce_admin_settings",
        subaction: "fields_data",
      })
    },
    saveChanges() {
      this.loading = true
      return http.post({
        action: "_wpcommerce_admin_settings",
        subaction: "save_data",
        data: JSON.stringify(this.values),
      })
    },
    exportSettings() {
      this.loading = true
      return http.post({
        action: "_wpcommerce_admin_settings",
        subaction: "export_settings",
      })
    },
  },
})